import React, { useState } from 'react';
import debounce from 'lodash/debounce';
import FilterSearch from '@jira/platform__filter-search-with-analytics/src/FilterSearchWithAnalytics.tsx';
import VisuallyHidden from '@atlaskit/visually-hidden';
import { type UIAnalyticsEvent, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useQueryParams } from '@atlassian/jira-software-router-utils/src/services/query-params/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import { QUERY_PARAM_SEARCH } from '../../common/constants.tsx';
import messages from '../messages.tsx';

const Search = (): React.JSX.Element => {
	const [queryParams, setQueryParams] = useQueryParams(QUERY_PARAM_SEARCH);
	const [currentStr, setCurrentStr] = useState<string>(queryParams[QUERY_PARAM_SEARCH]);
	const { formatMessage } = useIntl();

	const handleInputChange = debounce((searchStr: string, analyticsEvent: UIAnalyticsEvent) => {
		setCurrentStr(searchStr);
		setQueryParams({ [QUERY_PARAM_SEARCH]: searchStr });
		fireUIAnalytics(analyticsEvent, 'textFilterFilterSearch', {
			length: searchStr.length,
		});
	}, 300);

	return (
		<>
			{fg('releases_search_results_not_programmatically') ? (
				<FilterSearch
					onChange={handleInputChange}
					value={currentStr || ''}
					isAlwaysExpanded
					describedById="hiddentext1"
					placeholder=""
					hasAutoFocus={false}
					isCompact={false}
					increasedWidth={false}
					placeholderAlwaysVisible={false}
				/>
			) : (
				// @ts-expect-error - Type '{ onChange: DebouncedFunc<(searchStr: string, analyticsEvent: UIAnalyticsEvent) => void>; value: string; isAlwaysExpanded: true; }' is missing the following properties from type 'Omit<{ value: string; placeholder: string; describedById?: string | undefined; hasAutoFocus: boolean; isCompact: boolean; onChange: (value: string, args_1: UIAnalyticsEvent) => void; ... 6 more ...; key?: Key | ... 1 more ... | undefined; }, keyof WithAnalyticsEventsProps>': placeholder, hasAutoFocus, isCompact, increasedWidth, placeholderAlwaysVisible
				<FilterSearch onChange={handleInputChange} value={currentStr || ''} isAlwaysExpanded />
			)}
			{fg('releases_search_results_not_programmatically') && (
				<VisuallyHidden id="hiddentext1">{formatMessage(messages.searchMessage)}</VisuallyHidden>
			)}
		</>
	);
};

export default Search;
